export const transferIdParams = {
    operate_source: 'web',
    first_url: window.sessionStorage.getItem('first_url'),
    channel: window.sessionStorage.getItem('channel'),
    // user_type: getStore().getState().userInfoModel.userInfo?.is_vip ? 1 : 0
};
